import { LanguageSelect } from '@components/molecules/LanguageSelect';
import { useTranslation } from 'react-i18next';

export default function LangToggle() {
  const { i18n } = useTranslation();
  const current = (i18n.language || 'es').slice(0, 2) as 'es' | 'en';

  return (
    <LanguageSelect
      value={current}
      onChange={lang => i18n.changeLanguage(lang)}
    />
  );
}
